export default "/h5/static/images/not-login.png"